import { useEffect, useMemo } from 'react'
import classNames from 'classnames'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { findItem, certificationItems, sectionsPath } from '../../../utility/coachCertification'
import { useCoachCertification } from './useCoachCertification'
import CertificationNotice from './CertificationNotice'
import CertificationLoader from './CertificationLoader'
import ItemsRail from './ItemsRail'
import LessonView from './LessonView'
import QuizView from './QuizView'

import classes from './ItemPage.module.scss'

const ItemPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { certificationId, lessonId, quizId } = useParams()
  const { certification, notFound, failed } = useCoachCertification(certificationId)
  const items = useMemo(() => (certification ? certificationItems(certification) : []), [certification])
  const current = lessonId ? findItem(items, 'lesson', Number(lessonId)) : findItem(items, 'quiz', Number(quizId))
  const isOpen = !!current && (current.available || current.done)

  useEffect(() => {
    if (certification && !isOpen) { navigate(sectionsPath(certificationId), { replace: true }) }
  }, [certification, certificationId, isOpen, navigate])

  useEffect(() => { window.scrollTo(0, 0) }, [lessonId, quizId])

  if (notFound || failed) { return <CertificationNotice notFound={notFound} /> }
  if (!certification || !isOpen) { return <CertificationLoader /> }

  return (
    <main className={classes.page}>
      <div className={classes.content}>
        <Link to={sectionsPath(certificationId)} className={classes.back}>
          <i className='fa fa-arrow-left' aria-hidden='true' />
          {t('portal.certification.item.back')}
        </Link>
        {current.type === 'lesson'
          ? <LessonView key={current.id} item={current} items={items} sequential={certification.sequential} />
          : <QuizView key={current.id} item={current} items={items} certification={certification} />}
      </div>
      <ItemsRail certification={certification} items={items} current={current} className={classNames('d-none d-lg-block', classes.rail)} />
    </main>
  )
}

export default ItemPage
